var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3776 5.25625L7.31886 7.67208C6.89562 8.16873 6.684 8.41705 6.4056 8.41705C6.1272 8.41705 5.91558 8.16873 5.49234 7.67208L4.6224 6.65125M3.19276 2.94229C4.11274 3.1678 5.04975 2.63879 5.31003 1.74693C5.79524 0.0843558 8.20476 0.0843558 8.68997 1.74693C8.95025 2.63879 9.88725 3.1678 10.8072 2.94229C12.5223 2.52191 13.727 4.56244 12.4972 5.80464C11.8375 6.47099 11.8375 7.52901 12.4972 8.19536C13.727 9.43756 12.5223 11.4781 10.8072 11.0577C9.88725 10.8322 8.95025 11.3612 8.68997 12.2531C8.20476 13.9156 5.79524 13.9156 5.31003 12.2531C5.04975 11.3612 4.11274 10.8322 3.19276 11.0577C1.47774 11.4781 0.272983 9.43756 1.50279 8.19536C2.16249 7.52901 2.16249 6.47099 1.50279 5.80464C0.272983 4.56244 1.47774 2.52191 3.19276 2.94229Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.2f75947c8fbc30a147bec14b17390a88.svg";
export { ForwardRef as ReactComponent };